/**
 * True when the page runs on WebKit — Safari on macOS, and every browser on
 * iOS, since they are all WKWebView. It decides who gets Firestore long polling
 * (`./firebase.tsx`, WebKit bug 322545).
 *
 * `navigator.vendor`, not the user agent. WebKit reports "Apple Computer, Inc."
 * in every embedding, and an app cannot change it. The UA is exactly what
 * embeddings DO change: in-app browsers drop the "Safari" and "Version/"
 * tokens, iOS Chrome and Firefox say CriOS / FxiOS, iPadOS sends a Mac UA, and
 * a Blink browser on iOS (EU alternative engines) would send an iPhone UA
 * without having the bug. See TRAPS.md, "navigator.userAgent parsing".
 *
 * Both ways of being wrong are benign: a WebKit browser that slipped through
 * keeps the old transport, whose stalls the avatars list now bounds; anything
 * else caught by it gets long polling, which works everywhere, a little slower.
 */
export function isWebKitEngine(
  nav: Pick<Navigator, "vendor"> | null = typeof navigator === "undefined"
    ? null
    : navigator,
): boolean {
  return nav?.vendor === "Apple Computer, Inc.";
}
